module.exports = __webpack_public_path__ + "img/HowItWork_item_03.7ca47b63.png";